export default "__VITE_ASSET__DsOSnW0D__"